import {CircularProgress} from "@mui/material";
import styles from "./index.module.less";

interface ButtonProps {
  fullWidth?: boolean;
  loading?: boolean;
  onClick?: (e) => void;
  variant?: "outlined" | "contained";
  size?: "small" | "normal" | "more" | "large";
  type?: "primary" | "default";
  roundedAll?: boolean; //是否圆角
  children: string | React.ReactNode;
  subType?: "button" | "submit" | "reset";
}

export default function AppButton({
                                    loading = false,
                                    fullWidth,
                                    size = "normal",
                                    type = "primary",
                                    variant = "contained",
                                    onClick,
                                    children,
                                    roundedAll,
                                    subType = "button",
                                  }: ButtonProps) {
  const wrapperClasses = [
    styles["app-button"], 'cursor-pointer',
    size !== "normal" ? styles[`button-${size}`] : '',
    type === "primary" ? styles[`button-${variant}`] : '',
    styles[`button-${type}`],
    roundedAll ? styles["button-rounded"] : "",
    fullWidth ? styles["full-width"] : ""
  ];
  return (
    <button
      className={wrapperClasses.join(' ')}
      onClick={(e) => {
        if (!loading) {
          onClick?.(e)
        }
      }}
      type={subType}
    >
      {loading && (
        <span className={styles.loading}>
          {<CircularProgress size={20} color="info"/>}
        </span>
      )}
      <span>{children}</span>
    </button>
  );
}
